import React, { useEffect, useRef, useState } from 'react'
import avtar2 from '../../assets/images/user/avatar-2.jpg'
import { Link, useNavigate } from 'react-router-dom'
import { useProfile } from '../Context/ProfileContext';
import { imgUrl } from '../Services/api';

import TwoFactorModal from '../Auth/TwoFactorModal';

// ✅ Generate a short beep sound using Web Audio API — no audio file needed

const playNotificationSound = () => {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(880, ctx.currentTime);          // A5 note
        oscillator.frequency.setValueAtTime(660, ctx.currentTime + 0.1);    // E5 note
        gainNode.gain.setValueAtTime(0.3, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.4);
    } catch (e) {
        console.log('Audio not supported', e);
    }
};

const Header = ({ onToggleSidebar }) => {
    const { profile, fetchProfile } = useProfile();
    const navigate = useNavigate();

    // ✅ Notification state
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showDropdown, setShowDropdown] = useState(false);
    const [show2FAModal, setShow2FAModal] = useState(false);

    const prevUnreadRef = useRef(0);
    const pollIntervalRef = useRef(null);

    const handleLogout = async () => {
        localStorage.removeItem("token");
        localStorage.clear();
        navigate('/login');
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    // ✅ Fetch notifications and play sound if new ones arrive
    const fetchNotifications = async () => {
        try {
            const userId = localStorage.getItem('userId') || profile?.id;
            if (!userId) return;

            const token = localStorage.getItem('token');
            const res = await fetch(`${imgUrl}/api/v1/notification/${userId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            const notifs = data.notifications || [];
            const unread = notifs.filter(n => n.status === true || n.status === 1).length;

            // Play sound if new unread notifications arrived
            if (unread > prevUnreadRef.current) {
                playNotificationSound();
            }
            prevUnreadRef.current = unread;
            setNotifications(notifs.slice(0, 10)); // show latest 10
            setUnreadCount(unread);
        } catch (err) {
            console.log('Notification fetch error', err);
        }
    };

    // ✅ Start polling every 30 seconds
    useEffect(() => {
        if (!profile?.id) return;
        fetchNotifications();
        pollIntervalRef.current = setInterval(fetchNotifications, 30000);
        return () => clearInterval(pollIntervalRef.current);
    }, [profile?.id]);

    const handleBellClick = () => {
        setShowDropdown(prev => !prev);
        // Mark all as read via API when opened
        if (!showDropdown && unreadCount > 0) {
            setUnreadCount(0);
            prevUnreadRef.current = 0;
        }
    };

    const formatTime = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleString('en-IN', {
            day: '2-digit', month: 'short',
            hour: '2-digit', minute: '2-digit', hour12: true
        });
    };

    return (
        <>
            <header className="pc-header border">
                <div className="header-wrapper">
                    <div className="me-auto pc-mob-drp">
                        <ul className="list-unstyled">
                            <li className="pc-h-item pc-sidebar-collapse">
                                <Link to="#" className="pc-head-link ms-0" id="sidebar-hide" onClick={onToggleSidebar}>
                                    <i className="fas fa-bars" />
                                </Link>
                            </li>
                            <li className="pc-h-item pc-sidebar-popup">
                                <Link to="#" className="pc-head-link ms-0" id="mobile-collapse" onClick={onToggleSidebar}>
                                    <i className="fas fa-bars" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="ms-auto">
                        <ul className="list-unstyled d-flex align-items-center mb-0">

                            {/* ✅ Notification Bell */}
                            <li className="pc-h-item me-2" style={{ position: 'relative' }}>
                                <button
                                    className="pc-head-link btn btn-link p-2"
                                    onClick={handleBellClick}
                                    style={{ position: 'relative', border: 'none', background: 'none' }}
                                    title="Notifications"
                                >
                                    <i className="fas fa-bell f-20" style={{ color: unreadCount > 0 ? '#f0ad4e' : '#6c757d' }} />
                                    {unreadCount > 0 && (
                                        <span style={{
                                            position: 'absolute', top: 2, right: 2,
                                            background: '#dc3545', color: 'white',
                                            borderRadius: '50%', fontSize: 10,
                                            minWidth: 16, height: 16,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            fontWeight: 'bold', padding: '0 3px'
                                        }}>
                                            {unreadCount > 99 ? '99+' : unreadCount}
                                        </span>
                                    )}
                                </button>

                                {/* Notification Dropdown */}
                                {showDropdown && (
                                    <div style={{
                                        position: 'absolute', right: 0, top: '110%',
                                        width: 340, maxHeight: 420, overflowY: 'auto',
                                        background: '#fff', borderRadius: 8,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                        zIndex: 9999, border: '1px solid #e0e0e0'
                                    }}>
                                        <div style={{
                                            padding: '12px 16px', borderBottom: '1px solid #eee',
                                            display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                        }}>
                                            <strong style={{ fontSize: 14 }}>Notifications</strong>
                                            {unreadCount > 0 && (
                                                <span style={{ fontSize: 11, color: '#dc3545', fontWeight: 600 }}>
                                                    {unreadCount} unread
                                                </span>
                                            )}
                                        </div>
                                        {notifications.length === 0 ? (
                                            <div style={{ padding: 24, textAlign: 'center', color: '#999', fontSize: 13 }}>
                                                <i className="fas fa-bell-slash mb-2 d-block f-24" />
                                                No notifications
                                            </div>
                                        ) : (
                                            notifications.map((n, i) => (
                                                <div key={n.id || i} style={{
                                                    padding: '10px 16px',
                                                    borderBottom: '1px solid #f5f5f5',
                                                    background: (n.status === true || n.status === 1) ? '#fff8f0' : '#fff',
                                                    cursor: 'default'
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                                                        <span style={{
                                                            width: 8, height: 8, borderRadius: '50%', marginTop: 5, flexShrink: 0,
                                                            background: (n.status === true || n.status === 1) ? '#f0ad4e' : '#d0d0d0'
                                                        }} />
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ fontWeight: 600, fontSize: 13, color: '#333' }}>{n.title}</div>
                                                            <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>{n.description}</div>
                                                            <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
                                                                {n.sender?.username && <span style={{ marginRight: 6 }}>From: {n.sender.username}</span>}
                                                                {formatTime(n.createdAt)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                )}
                            </li>

                            {/* Profile Dropdown */}
                            <li className="dropdown pc-h-item header-user-profile">
                                <a
                                    className="pc-head-link dropdown-toggle arrow-none me-0"
                                    data-bs-toggle="dropdown"
                                    href="#"
                                    role="button"
                                    aria-haspopup="false"
                                    data-bs-auto-close="outside"
                                    aria-expanded="false"
                                >
                                    <img
                                        src={profile?.profile_image ? `${imgUrl}${profile?.profile_image}` : avtar2}
                                        alt="user-image"
                                        className="user-avtar"
                                    />
                                </a>
                                <div className="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                                    <div className="dropdown-header d-flex align-items-center justify-content-between">
                                        <h5 className="m-0">Profile</h5>
                                    </div>
                                    <div className="dropdown-body">
                                        <div
                                            className="profile-notification-scroll position-relative"
                                            style={{ maxHeight: "calc(100vh - 225px)" }}
                                        >
                                            <div className="d-flex mb-1">
                                                <div className="flex-shrink-0">
                                                    <img
                                                        src={profile?.profile_image ? `${imgUrl}${profile?.profile_image}` : avtar2}
                                                        alt="user-image"
                                                        className="user-avtar wid-35"
                                                    />
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <h6 className="mb-1">{profile?.username} 🖖</h6>
                                                    <span>{profile?.email}</span><br />
                                                    <span>Company ID: {profile?.company_id}</span>
                                                </div>
                                            </div>
                                            <hr className="border-secondary border-opacity-50" />
                                            <p className="text-span">Settings</p>
                                            <Link to="/profile" className="dropdown-item">
                                                <span>
                                                    <i className='fas fa-user pc-icon text-muted me-2'></i>
                                                    <span>Profile</span>
                                                </span>
                                            </Link>
                                            <Link to="/password" className="dropdown-item">
                                                <span>
                                                    <i className='fas fa-key pc-icon text-muted me-2'></i>
                                                    <span>Password Change</span>
                                                </span>
                                            </Link>
                                            <button 
                                                type="button" 
                                                className="dropdown-item btn-link border-0 text-start w-100"
                                                onClick={() => setShow2FAModal(true)}
                                            >
                                                <span>
                                                    <i className='fas fa-shield-alt pc-icon text-primary me-2'></i>
                                                    <span>Google 2FA Security</span>
                                                </span>
                                            </button>

                                            <hr className="border-secondary border-opacity-50" />
                                            <div className="d-grid mb-3">
                                                <button className="btn btn-primary" onClick={handleLogout}>
                                                    <i className="fas fa-right-from-bracket pc-icon me-2"></i>
                                                    Logout
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>

            {/* ✅ Close dropdown when clicking outside */}
            {showDropdown && (
                <div
                    onClick={() => setShowDropdown(false)}
                    style={{ position: 'fixed', inset: 0, zIndex: 9998 }}
                />
            )}

            <TwoFactorModal
                isOpen={show2FAModal}
                onClose={() => setShow2FAModal(false)}
            />
        </>
    );

};

export default Header;